/*
 * Types.
 */

interface PushSocketStatus {
  readonly connectionState: string;
  readonly privateChannel: {
    readonly isSubscribed: boolean;
    readonly isPending: boolean;
    readonly isCancelled: boolean;
  };
}

/*
 * State.
 */

let pushSocketStatusProvider: (() => PushSocketStatus) | undefined;

/*
 * API.
 */

export function setPushSocketStatusProvider(provider: (() => PushSocketStatus) | undefined) {
  pushSocketStatusProvider = provider;
}

export function getPushSocketStatus(): PushSocketStatus | undefined {
  return pushSocketStatusProvider?.();
}
